import {IOwnedEntity} from "@echo-nx/shared/common";
import {IMarlenkaOwner} from "./owner";

export interface ILogs extends IOwnedEntity<IMarlenkaOwner>{
  timestamp: Date,
  level: string, //enum
  message: string,
  meta?: any
}
